import { useCurrentDate } from "@sellar-io/components";
import { SupplierListResponseType } from "@sellar-io/api-v2/types";
import { formatDate } from "../../../utils/formatDate";
import { getNextDirectDeliveryDate } from "../../order/helpers/DeliveryDateHelpers/getNextDeliveryDate";
import OrderFulfillmentIndicator from "../../order/orderFulfillmentIndicator/OrderFulfillmentIndicator";

export const RenderConnectionDeliveryArea = ({
  deliveryArea,
  supplierOutOfOffice,
}: {
  deliveryArea?: SupplierListResponseType[number]["DeliveryArea"] | undefined;
  supplierOutOfOffice?:
    | SupplierListResponseType[number]["SupplierOutOfOffice"]
    | null;
}) => {
  const currentDate = useCurrentDate();
  const outOfOfficeReturnDate = supplierOutOfOffice?.outOfOffice
    ? supplierOutOfOffice.returnDate
    : null;
  const nextDeliveryDates = deliveryArea
    ? getNextDirectDeliveryDate({
        deliveryArea,
        startDateReference: outOfOfficeReturnDate ?? currentDate,
      })
    : null;

  if (!deliveryArea) return null;

  return (
    <div className="flex flex-wrap items-center gap-1">
      <OrderFulfillmentIndicator fulfillmentType={"direct"} />
      {!!nextDeliveryDates && (
        <div className={"flex flex-row gap-1 text-sm"}>
          Next Delivery:{" "}
          <strong>{formatDate(nextDeliveryDates.deliveryDate)}</strong>
        </div>
      )}
    </div>
  );
};
